/*页面级全局权限校验指令v-permission   ie不兼容：parentNode*/
import store from '@/store'

export default{
  inserted(el, binding, vnode) {
    const { value } = binding
    const roles = store.getters && store.getters.roles;
    //排除admin
		const roleflag=store.getters && store.getters.userinfo.role;
		if(roleflag==='admin'){
			 return true;
		}
		
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value

      const hasPermission = roles.some(role => {
        return permissionRoles.includes(role)
      })

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
    	console.error(`非法操作!需要权限`);
      throw new Error(`需要权限!`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/permission.js